<template>
  <div class='main'>
    <div class="main_left">
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        :router="true"
        :default-active="activePath"
      >
        <el-menu-item
          @click="saveNavState('/userinfo/basicinfomation')"
          index="/userinfo/basicinfomation"
        >
          <i class="el-icon-user-solid"></i>
          <span slot="title">基本信息</span>
        </el-menu-item>
        <el-menu-item
          @click="saveNavState('/userinfo/contact')"
          index="/userinfo/contact"
        >
          <i class="el-icon-phone"></i>
          <span slot="title">联系方式</span>
        </el-menu-item>
        <el-menu-item
          @click="saveNavState('/userinfo/changePW')"
          index="/userinfo/changePW"
        >
          <i class="el-icon-s-tools"></i>
          <span slot="title">修改密码</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main_right">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activePath: ''
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  methods: {
    saveNavState: function (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  display: flex;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 10px;
  .main_left {
    width: 190px;
    height: 100%;
    border: 1px solid #ccc;
  }
  .main_right {
    width: 100%;
    height: 100%;
    border: 1px solid #ccc;
    margin-left: 20px;
  }
}
</style>